<app-modal [(isOpen)]="isOpen" size="2xl">
  <ng-container header>
    Plus/Minus Sizing

    <span></span>
  </ng-container>

  <div body>
    @for (group of groupedAlternates(); track $index) {

      <div class="flex justify-between items-end">
        <div class="flex gap-2 items-center">
          @if (group.type === 'plus') {
            <app-badge variant="red">
              <div class="flex items-center">
                <app-icons icon="plus" width="12" svgClass=""/>
                Plus
              </div>
            </app-badge>
          }
          @else if (group.type === 'minus') {
            <app-badge variant="blue">
              <div class="flex items-center">
                <app-icons icon="minus" width="12" svgClass=""/>
                Minus
              </div>
            </app-badge>
          }
          @else {
            <app-badge>Stock</app-badge>
          }
        </div>

        <div class="text-2xs sm:text-xs text-body">{{group.description}}</div>

      </div>

      <app-hr class="my-1"></app-hr>

      @for (alternate of group.items; track $index) {
        <div class="bg-neutral-primary-soft block p-2 border border-default rounded shadow-xs mb-2 cursor-pointer"
             (click)="selectedAlternateFitment.set(alternate)"
             [class.!bg-brand-soft]="selectedAlternateFitment() === alternate">
          <div class="flex justify-between flex-wrap sm:flex-nowrap gap-1 sm:gap-0">
            <div class="flex items-center gap-2 justify-between w-full sm:w-auto">
              <div class="flex items-center gap-2">
                <app-icons icon="tire" width="25"/>
                {{ alternate.tire_size }}
              </div>
              <span class="text-xs text-body">{{ alternate.wheel_size }}"</span>
            </div>

            <div class="flex items-center gap-2 justify-between w-full sm:w-auto ms-0.5 sm:ms-0">
              <span class="text-sm text-body">
                @if (alternate.min_offset && alternate.max_offset) {
                  ET {{ alternate.min_offset }} - {{ alternate.max_offset }}
                }
              </span>
              <div class="flex gap-2 items-center">
                <app-badge [variant]="getPositionBadgeVariant(alternate.position)">
                  {{ alternate.position | titlecase }}
                </app-badge>
                <app-badge [variant]="getDiameterDifferenceBadgeVariant(alternate.tire_size, alternate.position)">
                  {{ calculateRollingDiameterDiff(alternate.tire_size, alternate.position) }}
                </app-badge>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>

  <div footer class="flex justify-between items-center">
    <span class="text-sm text-body">Select an alternate size to search</span>

    <div class="flex gap-2">
      <app-button class="hidden sm:block" variant="secondary" (click)="isOpen.set(false)">Cancel</app-button>

      <app-button (click)="onSubmit()" [disabled]="!selectedAlternateFitment()">
        <div class="flex no-wrap items-center gap-1">
          <span class="hidden sm:block">Search</span> <app-icons icon="arrow-right" svgClass=""/>
        </div>
      </app-button>
    </div>
  </div>
</app-modal>
